<template>
  <div class="big">
    <DocMsg :isFlag="doc_msg" :doctorId="doctorId"></DocMsg>
    <div class="page_title">医生新手任务</div>
    <div style="padding: 20px; border-radius: 5px">
      <div class="container">
        <div class="flex" style="justify-content: space-around">
          <div class="top_item">
            <div>
              <span class="black">{{ info.is_finish }}</span>
              <span class="gray">({{ info.is_no_finish }})</span>
              <el-tooltip
                class="item"
                effect="light"
                content="已完成任务的医生人数/医生总数"
                placement="top"
              >
                <el-button type="text" icon="el-icon-question"></el-button>
              </el-tooltip>
            </div>
            <div class="text">新手任务</div>
          </div>
          <div class="top_item">
            <div>
              <span class="black">￥{{ info.is_settlement_money }}</span>
              <el-tooltip
                class="item"
                effect="light"
                content="已结算的奖励金额"
                placement="top"
              >
                <el-button type="text" icon="el-icon-question"></el-button>
              </el-tooltip>
            </div>
            <div class="text">奖励金额</div>
          </div>
          <div class="top_item">
            <div>
              <span class="black">{{ info.finish_order }}</span>
              <span class="gray">({{ info.total_order }})</span>
              <el-tooltip
                class="item"
                effect="light"
                content="满足条件的订单数/订单总数"
                placement="top"
              >
                <el-button type="text" icon="el-icon-question"></el-button>
              </el-tooltip>
            </div>
            <div class="text">订单数</div>
          </div>
          <div class="top_item">
            <div>
              <span class="black">￥{{ info.finish_drug_price }}</span>
              <span class="gray">({{ info.total_drug_price }})</span>
              <el-tooltip
                class="item"
                effect="light"
                content="满足条件的药品总金额/药品总金额"
                placement="top"
              >
                <el-button type="text" icon="el-icon-question"></el-button>
              </el-tooltip>
            </div>
            <div class="text">药品金额</div>
          </div>
        </div>
        <div class="searchbox">
          <div class="item">
            <span class="title">医生姓名</span>
            <el-input
              placeholder="请输入"
              v-model="doctor_name"
              style="width: 160px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span class="title">医生手机号</span>
            <el-input
              placeholder="请输入"
              v-model="phone"
              style="width: 160px"
              @change="search"
              clearable
            ></el-input>
          </div>
          <div class="item">
            <span class="title">医生认证时间</span>
            <el-date-picker
              v-model="doctorTime"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="search"
            >
            </el-date-picker>
          </div>
          <div class="item">
            <span class="title">任务完成数量</span>
            <el-select
              v-model="count_finish"
              clearable
              placeholder="请选择"
              @change="search"
            >
              <el-option label="1" :value="1"> </el-option>
              <el-option label="2" :value="2"> </el-option>
              <el-option label="3" :value="3"> </el-option>
              <el-option label="4" :value="4"> </el-option>
            </el-select>
          </div>
          <div class="item">
            <span class="title">订单数</span>
            <el-input-number
              v-model="order_count"
              :min="0"
              :max="999999999"
              :precision="0"
              :controls="false"
              @change="orderCountChange"
            ></el-input-number>
          </div>
          <div class="item">
            <span class="title">是否关注歧黄助手</span>
            <el-radio-group v-model="is_subscribe" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="title">完成问诊设置</span>
            <el-radio-group v-model="is_reception" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="title">发布公告</span>
            <el-radio-group v-model="is_notice" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="title">开2单100元</span>
            <el-radio-group v-model="is_prescription" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已完成</el-radio>
              <el-radio :label="0">未完成</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="title">奖励状态</span>
            <el-radio-group v-model="is_reward" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">已奖励</el-radio>
              <el-radio :label="0">未奖励</el-radio>
            </el-radio-group>
          </div>
          <div class="item">
            <span class="title">是否测试</span>
            <el-radio-group v-model="is_test" @change="search">
              <el-radio :label="''">全部</el-radio>
              <el-radio :label="1">是</el-radio>
              <el-radio :label="0">否</el-radio>
            </el-radio-group>
          </div>

          <div class="item">
            <span class="title">任务完成时间</span>
            <el-date-picker
              v-model="prescription_time"
              type="daterange"
              align="right"
              unlink-panels
              value-format="yyyy-MM-dd"
              range-separator="至"
              start-placeholder="开始时间"
              end-placeholder="结束时间"
              @change="search"
            >
            </el-date-picker>
            <el-button
              type="info"
              style="
                background-color: #eceff2;
                color: #747981;
                margin-left: 16px;
              "
              @click="search"
              >查询</el-button
            >
            <el-button
              type="primary"
              @click="excelexport"
              :disabled="
                module_id_array[0] ? !module_id_array.includes('1415') : false
              "
              >导出</el-button
            >
          </div>
        </div>
        <div style="border: solid 1px #c9cbd6">
          <el-table
            ref="multipleTable"
            v-loading="tableLoading"
            :data="tableData"
            tooltip-effect="dark"
            style="width: 100%; min-width: 1000px"
            :header-cell-style="{ background: '#F5F5F5' }"
            @sort-change="sortChange"
          >
            <el-table-column label="医生信息">
              <template slot-scope="scope">
                <div
                  @click="showDocMsg(scope.row.doctor_id)"
                  style="cursor: pointer"
                >
                  {{ scope.row.doctor_name }}
                  <span style="margin-left: 10px">{{
                    scope.row.sex == 1 ? "男" : "女"
                  }}</span>
                </div>
                <div>{{ scope.row.phone }}</div>
              </template>
            </el-table-column>

            <el-table-column label="医生认证时间" prop="update_time">
            </el-table-column>

            <el-table-column label="医生所在医院" prop="hospital">
            </el-table-column>

            <el-table-column label="关注歧黄助手">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.is_subscribe">已完成</span>
                  <span v-else>未完成</span>
                </div>
                <div>{{ scope.row.subscribe_time }}</div>
              </template>
            </el-table-column>

            <el-table-column label="完成问诊设置">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.is_reception">已完成</span>
                  <span v-else>未完成</span>
                </div>
                <div>{{ scope.row.reception_time }}</div>
              </template>
            </el-table-column>

            <el-table-column label="发布公告">
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.is_notice">已完成</span>
                  <span v-else>未完成</span>
                </div>
                <div>{{ scope.row.notice_time }}</div>
              </template>
            </el-table-column>

            <el-table-column>
              <template slot="header">
                <span>开2单100元</span>
                <el-tooltip
                  class="item"
                  effect="light"
                  content="在线开方2单，每单药品金额100元，用户收货后即为完成当前任务"
                  placement="top"
                >
                  <el-button type="text" icon="el-icon-question"></el-button>
                </el-tooltip>
              </template>
              <template slot-scope="scope">
                <div>
                  <span v-if="scope.row.is_prescription">已完成</span>
                  <span v-else>未完成</span>
                </div>
                <div v-if="scope.row.is_prescription">
                  {{ scope.row.prescription_time }}
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="订单数"
              prop="order_count"
              sortable="custom"
            >
            </el-table-column>

            <el-table-column
              label="药品总金额"
              prop="drug_total_price"
              sortable="custom"
            >
              <template slot-scope="scope">
                <el-link type="primary" @click="lookDetail(scope.row.doctor_id)"
                  >￥{{ scope.row.drug_total_price }}</el-link
                >
              </template>
            </el-table-column>

            <el-table-column
              label="任务完成数量"
              prop="count_finish"
              sortable="custom"
            >
            </el-table-column>

            <el-table-column label="奖励状态">
              <template slot-scope="scope">
                <span v-if="scope.row.is_reward">
                  <span>已奖励</span>
                  <span v-if="scope.row.doc_settlement">（已结算）</span>
                  <span v-else>（待结算）</span>
                </span>
                <span v-else>未奖励</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div style="padding: 20px 0">
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 20, 50, 100]"
            :page-size="10"
            layout="total, sizes, prev, pager, next, jumper"
            :total="totalNum"
          ></el-pagination>
        </div>
      </div>
    </div>
    <!-- 医生任务详情 -->
    <el-dialog
      :title="gridInfo.doctor_name"
      width="800px"
      :visible.sync="dialogTableVisible"
    >
      <div style="padding: 20px">
        <div class="newbiTask-info-box">
          <div class="item-box">
            <div class="item">
              医生认证时间<span>{{ gridInfo.update_time | dateFormat2 }}</span>
            </div>
            <div class="item">
              医生所在医院<span>{{ gridInfo.hospital }}</span>
            </div>
          </div>
          <div class="item-box">
            <div class="item">
              订单数<span>{{ gridInfo.order_count }}</span>
            </div>
            <div class="item">
              订单总金额<span>￥{{ gridInfo.pay_total_price }}</span>
            </div>
            <div class="item">
              药品总金额<span>￥{{ gridInfo.drug_total_price }}</span>
            </div>
          </div>
        </div>
        <el-table :data="gridData" height="400px">
          <el-table-column
            property="order_sn"
            width="200"
            label="订单编号"
          ></el-table-column>
          <el-table-column
            property="user_name"
            label="患者姓名"
          ></el-table-column>
          <el-table-column label="订单状态">
            <template slot-scope="scope">
              <div>{{ scope.row.status | statusText }}</div>
            </template>
          </el-table-column>
          <el-table-column label="订单金额">
            <template slot-scope="scope">
              ￥<span>{{ scope.row.pay_money }}</span>
            </template>
          </el-table-column>
          <el-table-column label="药品金额">
            <template slot-scope="scope">
              ￥<span>{{ scope.row.drug_price }}</span>
            </template>
          </el-table-column>
          <el-table-column label="支付时间" width="200px">
            <template slot-scope="scope">
              <div>{{ scope.row.create_time | dateFormat2 }}</div>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <pagination
          v-show="gridTotalNum > 0"
          :total="gridTotalNum"
          :page.sync="gridPagination.page"
          :limit.sync="gridPagination.pageNumber"
          @pagination="doctorNewbieTaskDetail"
        />
      </div>
    </el-dialog>
  </div>
</template>
<script>
import dayjs from "dayjs";
import DocMsg from "../../../components/common/DocMsg.vue";
import marketing from "@/api/marketing";
import Pagination from "@/components/Pagination/index";
export default {
  data() {
    return {
      totalNum: 0,
      currentPage: 1,
      pagesize: 10,
      tableData: [],
      doctor_name: "",
      phone: "",
      is_subscribe: "",
      is_reception: "",
      is_notice: "",
      is_prescription: "",
      is_test: 0,
      is_reward: "",
      count_finish: "",
      info: {},
      doc_msg: false,
      doctorId: "",
      doctorTime: "",
      prescription_time: "",
      order_count: undefined,
      order_key: "",
      order_value: "",
      dialogTableVisible: false,
      gridInfo: {},
      gridData: [],
      gridPagination: {
        page: 1,
        pageNumber: 10,
      },
      gridTotalNum: 0,
    };
  },
  components: {
    DocMsg,
    Pagination,
  },
  filters: {
    dateFormat(date) {
      return dayjs.unix(date).format("YYYY-MM");
    },
    dateFormat2(val) {
      return !val ? "" : dayjs.unix(val).format("YYYY-MM-DD HH:mm:ss");
    },
    statusText(val) {
      switch (val) {
        case 1:
          return "待审核";
        case 2:
          return "待发药";
        case 3:
          return "待收货";
        case 4:
          return "已完成";
        case 5:
          return "不通过";
        case 6:
          return "平台退款";
      }
    },
  },
  computed: {
    module_id_array() {
      return this.$store.state.userInfo.userInfo.module_id_array || [];
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //医生信息概要
    showDocMsg(doctor_id) {
      this.doctorId = doctor_id;
      this.doc_msg = !this.doc_msg;
    },
    //获取列表
    getList() {
      let data = {
        page: this.currentPage,
        pageNumber: this.pagesize,
        doctor_name: this.doctor_name,
        phone: this.phone,
        is_subscribe: this.is_subscribe,
        is_reception: this.is_reception,
        is_notice: this.is_notice,
        is_prescription: this.is_prescription,
        is_test: this.is_test,
        is_reward: this.is_reward,
        start_time: this.doctorTime ? this.doctorTime[0] : "",
        end_time: this.doctorTime ? this.doctorTime[1] : "",
        prescription_start_time: this.prescription_time ? this.prescription_time[0] : "",
        prescription_end_time: this.prescription_time ? this.prescription_time[1] : "",
        count_finish: this.count_finish,
        order_key: this.order_key,
        order_value: this.order_value,
        order_count: this.order_count,
      };
      this.tableLoading = true;
      this.axios
        .post("platform/Activity/doctorNewbieTaskList", data)
        .then((res) => {
          if (res.code == 0) {
            this.tableData = res.data.list.map((item) => {
              item.subscribe_time = item.subscribe_time
                ? dayjs.unix(item.subscribe_time).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.reception_time = item.reception_time
                ? dayjs.unix(item.reception_time).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.notice_time = item.notice_time
                ? dayjs.unix(item.notice_time).format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.prescription_time = item.prescription_time
                ? dayjs
                    .unix(item.prescription_time)
                    .format("YYYY-MM-DD HH:mm:ss")
                : "";
              item.update_time = item.update_time
                ? dayjs.unix(item.update_time).format("YYYY-MM-DD HH:mm:ss")
                : "";
              return item;
            });
            this.info = res.data.info;
            this.totalNum = res.data.total;
          }
          this.tableLoading = false;
        })
        .catch((err) => (this.tableLoading = false));
    },

    //查看详情
    toDetail(sa_id) {
      this.$router.push({
        path: "settledetail",
        query: {
          sa_id,
          settlement_status: 2,
        },
      });
    },
    //搜索
    search() {
      this.currentPage = 1;
      this.getList();
    },
    //每页数据
    handleSizeChange(size) {
      this.pagesize = size;
      this.getList();
    },
    //翻页
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    //导出数据
    excelexport() {
      let data = {
        doctor_name: this.doctor_name,
        phone: this.phone,
        is_subscribe: this.is_subscribe,
        is_reception: this.is_reception,
        is_notice: this.is_notice,
        is_prescription: this.is_prescription,
        is_test: this.is_test,
        is_reward: this.is_reward,
      };
      let loading = this.$loading();
      this.axios
        .post("platform/Activity/exportDoctorNewbieTaskList", data)
        .then((res) => {
          if (res.code == 0) {
            let host =
              document.location.protocol +
              "//" +
              window.location.host +
              res.data.url;
            window.open(host);
          }
          loading.close();
        })
        .catch((err) => {
          loading.close();
        });
    },
    lookDetail(doctor_id) {
      this.diaDoctor_id = doctor_id;
      this.dialogTableVisible = true;
      this.doctorNewbieTaskDetail();
    },
    doctorNewbieTaskDetail() {
      let params = Object.assign(
        { doctor_id: this.diaDoctor_id },
        this.gridPagination
      );
      marketing.doctorNewbieTaskDetail(params).then((res) => {
        let { code, data } = res;
        if (code === 0) {
          this.gridInfo = data.info;
          this.gridData = data.list;
          this.gridTotalNum = data.total;
        }
      });
    },
    // 订单数改变
    orderCountChange(currentValue) {
      if (currentValue === "") {
        this.order_count = undefined;
      }
    },
    // 排序
    sortChange(value) {
      this.order_key = value.prop;
      this.order_value = value.order == "descending" ? "desc" : "asc";
      if (!value.order) {
        this.order_key = "";
        this.order_value = "";
      }
      this.getList();
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  padding: 20px;
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}
.searchbox {
  display: flex;
  flex-wrap: wrap;
  .item {
    margin-right: 30px;
    margin-bottom: 16px;
  }
}
.top_item {
  width: 300px;
  padding: 20px;
  box-sizing: border-box;
  border: solid 1px #d7d7d7;
  border-radius: 5px;
  margin: 0 20px 20px 0;
  box-shadow: 0 0 5px 0 #d7d7d7;
  .black {
    font-size: 26px;
  }
  .gray {
    font-size: 16px;
    color: #747981;
  }
  .text {
    font-size: 13px;
    color: #747981;
  }
}
.title {
  font-weight: 700;
  margin-right: 6px;
}
.newbiTask-info-box {
  // height: 100px;
  .item-box {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
    .item {
      margin-left: 10px;
      width: 34%;
      text-align: left;
      span {
        margin-left: 20px;
      }
    }
  }
}
</style>